// extracted by mini-css-extract-plugin
module.exports = {"consent-checkbox-container":"consent-checkbox-container-WV60T","label":"label-l3LSw","link":"link-UppYg"};